<template>
	<ul
		:class="[baseClass, isOpen ? 'is-open' : '']"
		:id="uid"
		:variant="variant"
	>
		<li
			:class="baseClass + separator + 'item'"
			:id="`${uid}_li`"
			:key="index"
			:title="option.title"
			v-for="(option, index) in options"
		>
			<ActionsSetAction
				:action="option.action"
				:page="option.page"
				:baseClass="baseClass + separator"
				:disabled="option.disabled"
				:iconClass="option.iconClass"
				:id="`${uid}_li_asa`"
				:label="option.label"
				:type="option.type"
				v-if="option.visible"
				:loggingParams="option.loggingParams"
			/>
		</li>
	</ul>
</template>

<script>
import ActionsSetAction from '@/site-components/actions-set/actions-set-action';

export default {
	name: 'ActionsSetMore',
	components: {
		ActionsSetAction
	},
	props: {
		isOpen: {
			type: Boolean,
			default: false
		},
		options: {
			type: Array,
			default: () => []
		},
		baseClass: {
			type: String,
			default: 'actions-set__submenu'
		}
	},
	computed: {
		separator() {
			return this.baseClass.indexOf('actions') > -1 ? '-' : '__';
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Actions Set More Menu - to be used in conjunction with actions-set component
    * Can use SCSS variables = TRUE
*/

.actions-set__submenu {
	display: none;
	box-shadow: 0px 2px 4px $neutral-3;
	border-radius: $card-border-radius;
	padding: $padding-xs 0;
	background-color: $white;
	@include text-contrast($white, $white, $black);
	z-index: 1;
	text-align: left;
	overflow: hidden;
	transition-timing-function: ease-in-out;
	transition: 0.4s;

	&.is-open {
		display: block;
	}

	&-action {
		display: inline-block;
		width: 100%;
		padding: $padding-xs $padding-sm;

		&:focus,
		&:hover {
			background: lighten($neutral-4, 5%);
			@include text-contrast(lighten($neutral-4, 5%), $white, $black);
		}

		&:active,
		&.is-active {
			background: $neutral-4;
			@include text-contrast($neutral-4, $white, $black);
		}
	}

	&-icon {
		margin-right: $gutter-md;
		vertical-align: middle;
	}

	&-label {
		vertical-align: middle;
		font-size: $default-font-size - 5;
	}
}
</style>
